import Menu from "./components/Menu";
import { Link } from "react-router-dom";
import "../css/Guias.css";
import { useEffect, useState } from "react";
import { ValidarSesion } from "../shared/Validaciones";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { NMTipoGuiaRemision} from '../shared/Denominaciones';
import Paginador from "./components/Paginador";
import { mostrarAviso } from "./components/Aviso";
import { ValidarNumLtr} from "../shared/Regex";

export default function Series(){
    // ==================================================================================================
    //#region HOOKS STATE
    // ==================================================================================================

    // ESTADOS DE FILTRO
    const[filtroSerie, setFiltroSerie] = useState("");
    const[filtroTipoGuia, setFiltroTipoGuia] = useState("");

    // ESTADOS DE SELECT
    const[selectTipoGuia, setSelectTipoGuia] = useState("");

    // ESTADOS DE CONTENIDO
    const[listaGuias, setListaGuias] = useState(<></>);

    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    // ==================================================================================================
    //#region HOOKS EFFECT
    // ==================================================================================================

    useEffect(()=>{
        ValidarSesion();
        ObtenerTiposGuia();
        ObtenerListaSeries(filtroSerie, filtroTipoGuia, 1);
    },[]);

    //#endregion    

    // ==================================================================================================
    //#region HANDLERS
    // ==================================================================================================

    // ESTADOS DE FILTRO
    const HandlerFiltroSerie = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroSerie(valor.toUpperCase());
        }
    }
    const HandlerFiltroTipoGuia = (valor) => setFiltroTipoGuia(valor);

    //ESTADOS DE SELECT
    const HandlerSelectTipoGuia = (lista) => {
        setSelectTipoGuia(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigo} >{NMTipoGuiaRemision(item.codigo)}</option>
        ))}</>)
    }

    // ESTADOS DE CONTENIDO
    const HandlerListaGuias = (lista) => setListaGuias(lista);
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);
    
    // ==================================================================================================
    //#region FUNCIONES
    // ==================================================================================================

    //FUNCIONES ASÍNCRONAS
    async function ObtenerTiposGuia(){
        try {
            let response = await axios.get(URL_TIPOS_GUIA, {
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }

            HandlerSelectTipoGuia(response.data.tipos);
        } catch (error) {
            console.log(error.message);
        }
    }
    async function ObtenerListaSeries(serie, tipoGuia, pagina){
        try{
            let response = await axios.get(URL_LISTAR_SERIES,{
                headers: HEADERS_API,
                params:{
                    tipoGuia: tipoGuia,
                    serie: serie,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerListaGuias(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error.message);
        }
    }
    function QuitarFiltros(){
        HandlerFiltroSerie("");
        HandlerFiltroTipoGuia("");
        ObtenerListaSeries();
    }
    async function CambiarEstadoSerie(tipoDoc, serie){
        try{
            let response = await axios.put(URL_CAMBIAR_ESTADO_SERIE,{
                tipoDoc: tipoDoc,
                serie: serie
            },{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });
            
        }catch(error){
            mostrarAviso(error, 2500); 
        }
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaSeries(filtroSerie, filtroTipoGuia, pagina);
    }

    //#endregion
    return (
        <>
        <Menu/>
        <div className="container">
            <div className="row">
                <div className="col-12 py-2 border-bottom border-secondary text-secondary">
                    <h2>{dB64(localStorage.getItem('r6'))}</h2>
                </div>
                <div className="col-12 py-3 text-center">
                    <h2>SERIES</h2>
                </div>
                <div className="col-12 p-2">
                    <Link to="/nueva-serie">
                        <button className="btn btn-primary">Nueva Serie</button>
                    </Link>
                </div>
                {/* FILTROS */}
                <div className="col-12 col-md-5 p-1">
                    <div className="form-floating">
                        <select onChange={(e)=>HandlerFiltroTipoGuia(e.target.value)} value={filtroTipoGuia} className="form-select" id="filtro-tipo-guia">
                            <option value="">Seleccionar</option>
                            {selectTipoGuia}
                        </select>
                        <label htmlFor="filtro-tipo-guia">Tipo GRE</label>
                    </div>
                </div>
                <div className="col-12 col-md-5 p-1">
                    <div className="form-floating">
                        <input onChange={e=>HandlerFiltroSerie(e.target.value)} value={filtroSerie} maxLength={4} type="text" className="form-control" placeholder="Serie" id="filtro-serie" autoComplete="off"/>
                        <label htmlFor="filtro-serie">Serie</label>
                    </div>
                </div>
                <div className="col-12 col-md-2 p-1">
                    <button onClick={e=>ObtenerListaSeries(filtroSerie, filtroTipoGuia, 1)} className="btn btn-primary w-100 my-1">Filtrar</button>
                    <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
                </div>
                {/* TABLA */}
                <div className="contenedor-tabla py-4">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Serie</th>
                                <th>Correlativo</th>
                                <th>Tipo de guía</th>
                                <th>Descripción</th>
                                <th>Activo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listaGuias.length > 0 ? listaGuias.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.serie}</td>
                                        <td>{item.numero + 1}</td>
                                        <td>{NMTipoGuiaRemision(item.tipoDocumento)}</td>
                                        <td>{item.descripcion}</td>
                                        <td>
                                            <div className="form-check form-switch">
                                                <input onChange={e=>CambiarEstadoSerie(item.tipoDocumento, item.serie)} defaultChecked={item.estado == "1" ? true : false} className="form-check-input" type="checkbox" role="switch"/>
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-center">
                    {paginador}
                </div>
            </div>
        </div> 
        </>
    );
}

// ==================================================================================================
//#region CONSTANTES
// ==================================================================================================

const URL_TIPOS_GUIA = process.env.REACT_APP_URL_TIPOS_GUIA;
const URL_LISTAR_SERIES = process.env.REACT_APP_URL_LISTAR_SERIES;
const URL_CAMBIAR_ESTADO_SERIE = process.env.REACT_APP_URL_CAMBIAR_ESTADO_SERIE;

//#endregion